export function normalizeWebsiteUrl(rawValue: string) {
  const value = rawValue.trim();

  if (!value) return "";

  if (/^https?:\/\//i.test(value)) {
    return value;
  }

  return `https://${value}`;
}

export function extractDomain(rawValue: string) {
  const normalized = normalizeWebsiteUrl(rawValue);

  if (!normalized) return "";

  try {
    const url = new URL(normalized);
    return url.hostname.replace(/^www\./i, "").toLowerCase();
  } catch {
    return rawValue
      .trim()
      .replace(/^https?:\/\//i, "")
      .replace(/^www\./i, "")
      .split("/")[0]
      .toLowerCase();
  }
}
